import React, {useState, useEffect, Fragment} from 'react'
import {Form, Input, Row, Col, Button, Table, Tag, message} from 'antd';
import {transferDateToValues,} from '../../utills/common'
import {getImportOrders, reqImportCustomsPorts} from "../../api";
import constants, {
    I_LOGISTICS_STATUS, I_ORDER_STATUS, I_SUB_TYPE, I_DELIVERY_TYPE, I_ENTRUST_TYPE,
} from "../../utills/constants";
import OptOrderModal from './opt-order-modal'
import SearchDrawer from "./search-drawer";

function ImportOrderList(props) {
    const {getFieldDecorator} = props.form;
    //数据源
    const [customsPortObj, setCustomsPortObj] = useState({});
    //table
    const [dataSource, setDataSource] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    //筛选drawer
    const [searchVisible, setSearchVisible] = useState(false);
    const [searchValue, setSearchValue] = useState({});
    //取消modal
    const [cancelVisible, setCancelVisible] = useState(false);
    const [cancelOrderId, setCancelOrderId] = useState(null);
    //table
    const columns = [{
        title: '订单编号',
        dataIndex: 'orderNo',
        width: 135,
        render: (text, record) => (
            <a onClick={() => props.history.replace('/import/orderView', {orderId: record.id})}>{text}</a>
        )
    }, {
        title: '运输类型',
        dataIndex: 'deliveryType',
        render: (text) => {
            return I_DELIVERY_TYPE[text]
        }
    }, {
        title: '委托方式',
        dataIndex: 'entrustType',
        render: (text, record) => {
            return I_ENTRUST_TYPE[record.deliveryType][text]
        }
    }, {
        title: '入境口岸',
        dataIndex: 'customsPort',
        render: (text, record) => {
            return customsPortObj[text]
        }
    }, {
        title: '预计抵达时间',
        dataIndex: 'estimatePortDt',
    }, {
        title: '服务类型',
        dataIndex: 'subType',
        width: 75,
        render: (text, record) => {
            return I_SUB_TYPE[record.deliveryType][text]
        }
    }, {
        title: '班列号',
        dataIndex: 'trainNo',
    }, {
        title: '清关/转关时间',
        dataIndex: 'declaredDt',
        width: 110,
    }, {
        title: '集装箱号',
        dataIndex: 'boxNo',
        width: 130,
    }, {
        title: '箱单号',
        dataIndex: 'boxNoteNo',
    }, {
        title: '提单号',
        dataIndex: 'ladingBillNo',
        width: 130,
    }, {
        title: '目的地',
        dataIndex: 'destinationCity',
    }, {
        title: '订单状态',
        dataIndex: 'orderStatus',
        width: 75,
        render: (text) => {
            return I_ORDER_STATUS[text]
        }
    }, {
        title: '物流状态',
        dataIndex: 'logisticsStatus',
        width: 75,
        render: (text) => {
            return I_LOGISTICS_STATUS[text]
        }
    }, {
        title: '操作',
        dataIndex: 'opt',
        render: (text, record) => {
            if (record.orderStatus === 'commit') {
                return <Fragment>
                    <Button type='link' onClick={() => clickCancel(record.id)}>取消</Button>
                    <Button type='link'
                            onClick={() => props.history.replace('/importDeliveryDetail', {orderId: record.id})}>查看物流</Button>
                </Fragment>
            }
            if (record.orderStatus === 'new' || record.orderStatus === 'failed') {
                return <Fragment>
                    <Button type='link'
                            onClick={() => props.history.replace('/import/order', {orderId: record.id})}>编辑</Button>
                    <Button type='link'
                            onClick={() => props.history.replace('/importDeliveryDetail', {orderId: record.id})}>查看物流</Button>
                </Fragment>
            }
            return <Button type='link'
                           onClick={() => props.history.replace('/importDeliveryDetail', {orderId: record.id})}>查看物流</Button>
        }
    }]
    //口岸
    const getCustomsPorts = async (deliveryType) => {
        let result = await reqImportCustomsPorts(deliveryType);
        if (result.code === 200) {
            const data = {};
            (result.data || []).forEach(o => {
                data[o.customsPortCode] = o.customsPortName
            })
            setCustomsPortObj(data)
        } else {
            message.error(result.message)
        }
    }
    //点击查询后表单提交
    const getProducts = async (values = {}, pageNum = 1, pageSize = 10) => {
        const po = {...values, ...searchValue, pageNum, pageSize,}
        transferDateToValues(po, ['estimatePortDt', 'declaredDt']);
        let result = await getImportOrders(po);
        if (result.code == 200) {
            setPageNum(pageNum);
            setPageSize(pageSize)
            setDataSource(result.data.rows);
            setTotal(result.data.total);
        } else {
            message.error(result.message)
        }
    };
    const handleSubmit = (e) => {
        e && e.preventDefault();
        getProducts(props.form.getFieldsValue());
    };
    //筛选
    const search = () => {
        setSearchVisible(true);
    }
    const onClose = () => {
        setSearchVisible(false);
    }
    const closeTag = (e, key) => {
        e.preventDefault();
        const searches = {...searchValue}
        delete searches[key]
        setSearchValue(searches)
    }
    // 取消订单操作
    const clickCancel = (orderId) => {
        setCancelVisible(true);
        setCancelOrderId(orderId)
    }
    const onCancel = () => {
        setCancelVisible(false);
        setCancelOrderId(null)
    }
    useEffect(() => {
        getCustomsPorts()
    }, []);
    useEffect(() => {
        handleSubmit()
    }, [searchValue]);
    return <div className='box-shadow padding-20'>
        <div className='head-title'>进口运输订单</div>
        <br/>
        <Form layout='inline' onSubmit={handleSubmit}>
            <Row>
                <Col span={16}>
                    <Form.Item label="订单编号">
                        {getFieldDecorator('orderNo', {})(<Input/>)}
                    </Form.Item>
                    <Button type='primary' htmlType="submit">查询订单</Button>
                </Col>
                <Col span={8}>
                    <Button className='margin-btn-last' type='primary' style={{float: 'right'}}
                            onClick={search}>筛选</Button>
                    <Button className='margin-btn' htmlType="button" style={{float: 'right'}}
                            onClick={() => props.history.push('/import/order')}>新增</Button>
                </Col>
                <Col span={24}>
                    {Object.keys(searchValue).map(key => {
                        const value = searchValue[key];
                        if (value && key === 'customsPort') {
                            return <Tag closable onClose={e => closeTag(e, key)}>入境口岸：{customsPortObj[value]}</Tag>
                        }
                        if (value && Array.isArray(value) && value.length === 2) {//时间
                            return <Tag closable onClose={e => closeTag(e, key)}>
                                {constants.SEARCH[key].name}：{value[0].format('YYYY-MM-DD')}~{value[1].format('YYYY-MM-DD')}
                            </Tag>
                        }
                        if (value && constants.SEARCH[key]) {
                            const source = constants[constants.SEARCH[key].source]
                            return <Tag closable onClose={e => closeTag(e, key)}>
                                {constants.SEARCH[key].name}：{source ? source[value] : value}
                            </Tag>
                        }
                    })}
                </Col>
            </Row>
        </Form>
        <Table
            columns={columns}
            bordered
            dataSource={dataSource}
            rowKey='id'
            scroll={{x: 1600}}
            pagination={{
                current: pageNum,
                total: total,
                showQuickJumper: true,
                onChange: (pageNum) => getProducts(props.form.getFieldsValue(), pageNum)
            }}
            size="middle"
        />
        <SearchDrawer visible={searchVisible} searchValue={searchValue}
                      onClose={onClose} setSearchValue={setSearchValue} customsPortObj={customsPortObj}/>
        <OptOrderModal visible={cancelVisible} orderId={cancelOrderId} optType='cancel'
                       onCancel={onCancel} refreshFun={handleSubmit}/>
    </div>
}

export default Form.create()(ImportOrderList);